import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, AlertCircle } from "lucide-react";

const SECTIONS = [
    {
        title: "Mentions légales",
        body: [
            "Éditeur du site : Ergocox™ — entreprise individuelle en cours d’immatriculation (numéro SIRET en cours d’obtention). Gérant : [Votre nom et prénom à compléter]. Adresse : [Votre adresse à compléter]. Contact : [Votre e-mail de contact à compléter], [Votre téléphone à compléter].",
            "Responsable de la publication : [À compléter — nom du responsable].",
            "Hébergement : Emergent (plateforme cloud). Paiements traités par Stripe, Inc. — le marchand ne stocke aucune donnée bancaire.",
        ],
    },
    {
        title: "Conditions Générales de Vente",
        body: [
            "Prix : les prix affichés sont en euros, toutes taxes comprises. Les packs disponibles sont : 1x coussin à 49,90 €, 2x Pack Duo à 89,80 € et 3x Pack Famille à 127,20 €.",
            "Paiement : le paiement s'effectue en ligne via Stripe (carte bancaire, PayPal). La commande est confirmée après validation du paiement.",
            "Livraison : livraison suivie offerte en France métropolitaine, sous 8 à 12 jours en moyenne. Un numéro de suivi est communiqué au client dès l'expédition de son colis.",
            "Droit de rétractation : conformément aux articles L221-18 et suivants du Code de la consommation, le client dispose d'un délai de 14 jours à compter de la réception pour se rétracter, sans motif. Retour aux frais du client dans l'état d'origine.",
            "Garantie commerciale : le client bénéficie en outre d'un essai de 30 nuits — satisfait ou remboursé. Les produits sont couverts par les garanties légales de conformité et des vices cachés.",
            "Réclamations : [À compléter — e-mail de réclamation]. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire.",
        ],
    },
    {
        title: "Confidentialité & données personnelles",
        body: [
            "Données collectées : nom, e-mail, téléphone et adresse de livraison, uniquement pour le traitement et l'expédition de votre commande, ainsi que pour l'envoi des e-mails associés (confirmation, expédition, avis).",
            "Paiement : les informations de paiement sont traitées directement par Stripe. Le marchand n'a jamais accès à vos données bancaires complètes.",
            "Conservation : vos données sont conservées le temps strictement nécessaire au suivi de votre commande et de ses garanties. Elles ne sont jamais revendues.",
            "Vos droits (accès, rectification, suppression, portabilité) : [À compléter — e-mail de contact RGPD]. Vous pouvez également introduire une réclamation auprès de la CNIL.",
        ],
    },
];

export default function Legal() {
    return (
        <div className="min-h-screen bg-cream text-ink font-sans" data-testid="legal-page">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 lg:py-16">
                <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-sage hover:text-sage-hover transition-colors">
                    <ArrowLeft size={16} /> Retour à la boutique
                </Link>
                <h1 className="mt-6 font-serif text-3xl sm:text-4xl tracking-tight">Informations légales</h1>
                <div className="mt-8 inline-flex items-start gap-2.5 rounded-xl bg-terra-soft p-4 text-xs text-ink/80 leading-relaxed">
                    <AlertCircle size={16} className="shrink-0 text-terra mt-0.5" />
                    <span>
                        Statut : entreprise individuelle en cours d’immatriculation (micro-entrepreneur).
                        Dès réception de votre numéro SIRET et de vos coordonnées, remplacez les champs
                        [À compléter] — ou demandez-le moi.
                    </span>
                </div>
                <div className="mt-10 flex flex-col gap-10">
                    {SECTIONS.map((s, i) => (
                        <motion.section
                            key={i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.05 }}
                            data-testid={`legal-section-${i}`}
                            className="rounded-3xl bg-white border border-sage/15 p-6 sm:p-8"
                        >
                            <h2 className="font-serif text-2xl text-sage">{s.title}</h2>
                            <div className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-[#4A5550]">
                                {s.body.map((p, j) => (
                                    <p key={j}>{p}</p>
                                ))}
                            </div>
                        </motion.section>
                    ))}
                </div>
                <p className="mt-10 text-xs text-ink/40">
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                </p>
            </div>
        </div>
    );
}
